import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const WebDesignIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 50 47" fill="none">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={3}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M32.6914 38.806L12.7924 37.0651C11.9033 36.9873 11.0181 36.2076 10.8547 35.3422L5.9401 10.2709C5.24294 6.67752 6.87315 5.7349 9.54009 8.13871L16.8686 14.7168C18.095 15.7816 19.738 15.436 20.5734 13.9557L25.8582 4.43807C27.5423 1.39353 29.511 1.56577 30.1979 4.81774L32.3646 14.9873C32.7147 16.5713 34.2047 17.1911 35.7091 16.3651L44.3247 11.565C47.9994 9.50322 49.3976 10.8385 47.441 14.5188L35.129 37.5084C34.6852 38.2782 33.5805 38.8838 32.6914 38.806Z"
			/>

			<g opacity={0.4}>
				<path fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" d="M10.095 43.2551L33.381 45.2924" />
				<path fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" d="M19.105 27.02L29.6895 27.946" />
			</g>
		</SvgIcon>
	)
}

export default WebDesignIconAtom
